module.exports = __webpack_public_path__ + "static/petsure-7d3cc32c0419df8daff61d2d2079bcd9.png";